import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { toast } from 'react-toastify';
import { PersistGate } from 'redux-persist/integration/react';

import GlobalStyle from './styles/global';
import { persistor } from './store';
import { Routes } from 'routes';
import Warden from 'Warden';
import ActivityMonitor from 'components/ActivityMonitor';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Toaster } from 'components/ui/sonner';
toast.configure();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false, // default: true
    },
  },
});

const App: React.FC = () => {
  return (
    <PersistGate loading={null} persistor={persistor}>
      <Warden />
      <ActivityMonitor />
      <BrowserRouter basename="/base">
        <Toaster />
        <QueryClientProvider client={queryClient}>
          <GlobalStyle />
          <Routes />
        </QueryClientProvider>
      </BrowserRouter>
    </PersistGate>
  );
};

export default App;
